import React from 'react';

const Legend = ({ legendConfigs }) => {
  return (
    <div className="gradient-legend">
      
    </div>
  );
};

export default Legend;
